import React from 'react';
import { Target, Globe, Award, Heart, Sparkles } from 'lucide-react';

export const About = () => {
  const values = [
    {
      icon: Target,
      title: "Our Mission",
      description: "To offer world-class M&E services that transform data into actionable insights and sustainable impact.",
      gradient: "gradient-primary"
    },
    {
      icon: Globe,
      title: "Our Vision", 
      description: "A development landscape where every development initiative is evidence-based, delivers intended results and creates lasting positive change for communities.",
      gradient: "gradient-warm"
    },
    {
      icon: Heart,
      title: "Our Values",
      description: "Evidentia Africa is guided by integrity, excellence, and collaboration in delivering credible, data-driven insights that advance development.",
      gradient: "gradient-nature"
    }
  ];



  const differentiators = [
    {
      icon: Sparkles,
      title: "Fresh Innovation",
      description: "Bringing cutting-edge methodologies to traditional M&E challenges",
      gradient: "gradient-primary"
    },
    {
      icon: Globe,
      title: "Local Context",
      description: "Deep understanding of development landscapes and cultural nuances",
      gradient: "gradient-warm"
    },
    {
      icon: Award,
      title: "Quality Focus",
      description: "Commitment to excellence and adherence to data quality standards in every project",
      gradient: "gradient-nature"
    }
  ];

  return (
    <section id="about" className="section-padding bg-white relative overflow-hidden">
      
      {/* Background elements */}
      <div className="absolute inset-0 pattern-african opacity-15"></div>
      <div className="absolute top-1/4 right-1/4 w-96 h-96 gradient-warm rounded-full opacity-5 blur-3xl animate-bounce-subtle"></div>
      <div className="absolute bottom-1/3 left-1/4 w-80 h-80 gradient-nature rounded-full opacity-5 blur-3xl animate-bounce-subtle" style={{animationDelay: '2s'}}></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* Hero section */}
        <div className="text-center max-w-5xl mx-auto mb-24 animate-fadeInUp">
          <h2 className="text-section text-gray-900 mb-8 leading-tight">
            <span className="text-gradient-primary">Overview</span>
          </h2>
          
          <p className="text-xl-responsive text-gray-600 leading-relaxed font-medium">
            Evidentia Africa is a one stop shop for Monitoring and Evaluation solutions. We offer a range of advanced and complementally Monitoring and Evaluation solutions customized to your unique development challenges and opportunities. We incorporate digital solutions and artificial intelligence into our operations, combine innovative methodologies with deep local expertise to generate high-quality data and contextually relevant evidence. Evidentia Africa Ltd was found in Rwanda in 2013. Our offices are in Kigali, Rwanda, and we are working towards expanding our presence throughout the region and across the continent.
          </p>
        </div>

        {/* Mission, Vision & Values with African inspiration */}
        <div className="grid lg:grid-cols-3 gap-12 mb-32">
          {values.map((value, index) => {
            const Icon = value.icon;
            
            return (
              <div key={index} className={`animate-slideInLeft`} style={{animationDelay: `${index * 0.2}s`}}>
                <div className="card-modern text-center h-full group hover:scale-105 transition-all duration-500">
                  
                  {/* Icon with African gradient */}
                  <div className="relative mb-8">
                    <div className={`w-20 h-20 ${value.gradient} rounded-3xl flex items-center justify-center mx-auto shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:rotate-3`}>
                      <Icon className="w-10 h-10 text-white" />
                    </div>
                    <div className={`absolute -inset-3 ${value.gradient} rounded-3xl opacity-0 group-hover:opacity-20 blur-xl transition-all duration-300`}></div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 group-hover:text-gradient-primary transition-all duration-300">
                    {value.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed font-medium text-lg">
                    {value.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>



        {/* Why choose us with African spirit */}
        <div className="card-modern bg-gradient-to-br from-teal-50/30 via-orange-50/20 to-emerald-50/30 relative overflow-hidden animate-fadeInUp">
          <div className="absolute inset-0 pattern-african opacity-10"></div>
          
          <div className="relative text-center">
            <div className="mb-12">
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                <span className="text-gradient-primary">Our Strength</span>
              </h3>
            </div>

            <div className="grid lg:grid-cols-3 gap-10 mb-12">
              {differentiators.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className={`text-center group animate-scaleIn`} style={{animationDelay: `${index * 0.2}s`}}>
                    <div className="relative mb-6 inline-block">
                      <div className={`w-16 h-16 ${item.gradient} rounded-2xl flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                        <Icon className="w-8 h-8 text-white" />
                      </div>
                      <div className={`absolute -inset-2 ${item.gradient} rounded-2xl opacity-0 group-hover:opacity-20 blur-xl transition-all duration-300`}></div>
                    </div>
                    
                    <h4 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-gradient-primary transition-all duration-300">{item.title}</h4>
                    <p className="text-gray-600 leading-relaxed font-medium">{item.description}</p>
                  </div>
                );
              })}
            </div>

 
          </div>
        </div>
      </div>
    </section>
  );
};